import { createIcon } from '../createIcon';

export const RulerHorizontalIconConfig = {
  name: 'RulerHorizontalIcon',
  height: 512,
  width: 576,
  svgPath: 'M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const RulerHorizontalIcon = createIcon(RulerHorizontalIconConfig);

export default RulerHorizontalIcon;